export default function initHeaderScroll() {
    const header = document.querySelector('[data-elementor-type="header"]');
    if (!header) return;

    // Fade the header's background (only — logo/nav/button stay fully
    // opaque, see #header-bg in global.css) from a starting opacity at the
    // top of the page up to full opacity by 300px scrolled. Mobile starts
    // much closer to solid (0.9) since there's no hero content behind the
    // header to see through on small screens.
    const START_OPACITY_DESKTOP = 0.25;
    const START_OPACITY_MOBILE = 0.9;
    const MOBILE_BREAKPOINT_PX = 768;
    const FADE_END_PX = 300;

    const update = () => {
        const startOpacity = window.innerWidth <= MOBILE_BREAKPOINT_PX
            ? START_OPACITY_MOBILE
            : START_OPACITY_DESKTOP;
        const percent = Math.min(window.scrollY / FADE_END_PX, 1);
        const opacity = startOpacity + percent * (1 - startOpacity);
        header.style.setProperty('--sh-header-bg-opacity', opacity);
        header.classList.toggle('is-scrolled', window.scrollY > 10);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
}
